export enum RolesEnum {
  User = 'USER',
  Admin = 'ADMIN'
}
